import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-duty-view',
  templateUrl: './duty-view.component.html',
  styleUrls: ['./duty-view.component.scss']
})
export class DutyViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
